
	frappe.templates['address_list'] = `{% if (addr_list.length) { %}
	<div class="card-list-actions">
		{%= frappe.ui.button.html({ label: __("Address"), icon: "plus", size: "sm", css_class: "btn-address" }) %}
	</div>
{% } %}

<div class="clearfix"></div>
{% for (const addr of addr_list) { %}
	<div class="address-box" data-name="{%= frappe.utils.escape_html(addr.name) %}">
		{%= frappe.ui.button.html({ icon: "ellipsis", variant: "ghost", size: "sm", title: __("Options"), css_class: "card-menu-btn" }) %}
		<div class="box-header flex items-center flex-wrap gap-2">
			<span class="text-base-semibold text-ink-gray-8">{%= frappe.utils.escape_html(addr.address_title) %}</span>
			{% if (addr.name === primary_name) { %}
				{%= frappe.ui.badge.html({ label: __("Primary"), size: "sm" }) %}
			{% } %}
		</div>
		{% const tags = [addr.address_type !== "Other" ? frappe.utils.escape_html(__(addr.address_type)) : null, addr.is_shipping_address ? __("Shipping") : null, addr.disabled ? __("Disabled") : null].filter(Boolean).join(" · "); %}
		{% if (tags) { %}
			<div class="box-subtitle text-sm text-ink-gray-5">{%= tags %}</div>
		{% } %}
		<div class="address-display text-ink-gray-7">{%= addr.display %}</div>
	</div>
{% } %}

{% if (!addr_list.length) { %}
	{%= frappe.ui.empty_state.html({
		icon: "map-pin",
		title: __("No addresses added yet"),
		actions: [{ label: __("New Address"), icon: "plus", css_class: "btn-address" }],
	}) %}
{% } %}
`;
